module.exports = __webpack_public_path__ + "img/staff-pic1.54bd3ce5.png";